import React from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';
import CSSModules from 'react-css-modules';

import SimpleAvatar from '../../../common/SimpleAvatar';
import styles from './styles.styl';

function ProviderNameAvatar({
  provider,
  avatarSize,
  renderMeta,
  withoutLocation,
}) {
  const { name: providerName, avatar, location } = provider || {};
  const { name: locationName } = location || {};

  return (
    <div styleName="root">
      <SimpleAvatar
        src={get(avatar, 'thumbMin')}
        text={providerName}
        size={avatarSize}
        bordered
      />
      <div styleName="name">
        <span styleName="strong">{providerName}</span>
        <span styleName="meta">{renderMeta(provider)}</span>
        {locationName && !withoutLocation && (
          <span styleName="meta" className="mt1">
            {locationName}
          </span>
        )}
      </div>
    </div>
  );
}

ProviderNameAvatar.propTypes = {
  renderMeta: PropTypes.func,
  provider: PropTypes.object,
  avatarSize: PropTypes.number,
  withoutLocation: PropTypes.bool,
};

ProviderNameAvatar.defaultProps = {
  avatarSize: 68,
  renderMeta: () => {},
  withoutLocation: false,
};

export default CSSModules(ProviderNameAvatar, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/ProviderNameAvatar/index.jsx